import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { useLoyaltyStore } from '../../hooks';
import { getLoyaltyIconByMachineType } from '../../loyalty.constants';

import styles from './LoyaltyBalanceIcon.module.css';

export const LoyaltyBalanceIcon = (): JSX.Element => {
    const { t } = useTranslation();

    const machineTypeId = useAppStore((state) => state.vm.type_id);
    const currentBalance = useLoyaltyStore((state) => state.currentBalance);
    const pointsToShowLoyaltyBonus = useLoyaltyStore(
        (state) => state.pointsToShowLoyaltyBonus,
    );
    const isPrizeAvailable = useLoyaltyStore((state) =>
        state.isPrizeAvailable(),
    );

    const badgeClass = isPrizeAvailable
        ? styles.badgeReady
        : styles.badgeThemed;

    const tooltipText = isPrizeAvailable
        ? t('loyalty.balanceIcon.tooltipPrizeReady')
        : t('loyalty.balanceIcon.tooltipDefault');

    const MachineIcon = getLoyaltyIconByMachineType(machineTypeId);

    return (
        <div
            className={`${styles.badge} ${badgeClass}`}
            title={tooltipText}
        >
            <span className={styles.icon}>
                <MachineIcon size="medium" />
            </span>
            <span>{`${currentBalance} / ${pointsToShowLoyaltyBonus}`}</span>
        </div>
    );
};
